import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import PageTemplate from "@/components/page-template/PageTemplate";
import SubscriptionPlanForm from "./SubscriptionPlanForm";
import { anythinkPayService } from "@/services/breeze/AnythinkPayService";
import { LoadingScreen } from "@/components/ui/LoadingScreen";
import ErrorCard from "@/components/ui/ErrorCard";

export default function EditSubscriptionPlanPage() {
  const params = useParams();
  const planId = parseInt(params.planId as string, 10);

  const {
    data: plan,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["subscription-plan", planId],
    queryFn: () => anythinkPayService.getSubscriptionPlan(planId),
    enabled: Number.isInteger(planId),
  });

  if (isLoading) return <LoadingScreen />;
  if (error) return <ErrorCard error={error.message} />;
  if (!plan) return null;

  return (
    <PageTemplate
      title={`Edit: ${plan.plan_name}`}
      description="Update this subscription plan."
    >
      <SubscriptionPlanForm planId={planId} plan={plan} />
    </PageTemplate>
  );
}
